import { render, staticRenderFns } from "./SharedTag.vue?vue&type=template&id=006f6d00"
import script from "./SharedTag.vue?vue&type=script&lang=js"
export * from "./SharedTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports